import { useEffect } from 'react';
import usePagination, { type PaginationInit } from './usePagination';
import useEntitiesSelector from './useEntitiesSelector';

export default function useStorePagination(props: PaginationInit) {
  const { items, removeItem, ...rest } = usePagination(props);
  const storeItems: any[] = useEntitiesSelector(
    items?.[0]?.meta?.type,
    items?.map((item: any) => item?.meta?.id),
  );

  useEffect(() => {
    if (items && storeItems.length !== items.length) {
      items.forEach((item: any) => {
        if (!storeItems.find((i: any) => i?.meta?.id === item?.meta?.id)) {
          removeItem(item);
        }
      });
    }
  }, [storeItems, items, removeItem]);

  return { items: storeItems, removeItem, ...rest };
}
